import { cloneDeep } from "lodash";
import {
  CheckboxInput,
  SANS_2,
  SkeletonLoader,
  TextInput,
  UI_BODY_SEMIBOLD_SM_DF,
  colors,
  colors2,
  getVal,
  icons,
  makeArrayFromLength,
} from "oolib";
import React, { useEffect, useRef, useState } from "react";

import {
  convertMultiValueToTagsValue,
  convertTagDocsDataToOptions,
  convertTagsValueToMultiValue,
  useGetTypeCategoryAndTags,
} from "../../../../../../../../DynamicTagsInputs/utils";

import { AddNewTagInput } from "../AddNewTagInput";
import {
  AddOthersStyled,
  StyledSearchWrapper,
  SubMenuContainerStyled,
  SubMenuItemStyled,
  SubMenuWrapperStyled,
} from "../../styled";
import TagsInputMulti from "@/components/inputs/DynamicTagsInputs/TagsInputMulti";
import { __GetContentTypeConfigNew } from "@/utils/getters/gettersV2";

const { greyColor5 } = colors;
const { Plus, CaretUp, CaretDown } = icons;

const LightboxFilterModule = ({
  lightboxFilterConfigs,
  setActiveLightboxFilters,
  activeLightboxFilters,
}) => {
  const [expand, setExpand] = useState(false);
  return (
    <div>
      <button
        onClick={() => setExpand((prev) => !prev)}
        style={{
          cursor: "pointer",
          width: "100%",
          border: "none",
          background: "none",
          padding: "0.8rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <UI_BODY_SEMIBOLD_SM_DF>Filters</UI_BODY_SEMIBOLD_SM_DF>
        {expand ? <CaretUp size={12} /> : <CaretDown size={12} />}
      </button>
      <div
        style={{
          overflow: expand ? "visible" : "hidden",
          height: expand ? "auto" : 0,
        }}
      >
        <div
          style={{
            padding: "0.8rem",
            display: "grid",
            gridTemplateColumns: makeArrayFromLength(
              lightboxFilterConfigs.length
            )
              ?.map((x) => "1fr")
              .join(" "),
            gap: "0.4rem",
            background: colors2.grey2,
          }}
        >
          {lightboxFilterConfigs?.map((d) => (
            <div style={{ flex: "0 0 50%" }}>
              <TagsInputMulti
                S
                isSearchable
                isTagsStyle={false}
                popOutOfOverflowHiddenParent
                label={
                  __GetContentTypeConfigNew(d.tagType)?.general?.content
                    ?.title || d.tagType
                }
                value={activeLightboxFilters?.[d.tagType]}
                tagType={d.tagType}
                onChange={(k, v) =>
                  setActiveLightboxFilters((prev) => ({
                    ...prev,
                    [d.tagType]: v,
                  }))
                }
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

//------------------------------------- SUB MENU COMPONENTS ----------------------------------------------------

export const TagsSubmenu = ({
  showTagsLightbox,
  containerRef,
  value, // this is basically the 'state value' of all the selected anno tags currently. eg. { useCases: { collectionId: 'useCases', data: [ {_id, display, tagId}, ... ]}, ... }
  onChange,
}) => {
  const [activeLightboxFilters, setActiveLightboxFilters] = useState(undefined);
  /** shape of activeLightboxFilters:
   * {
   *   <tagType1>: { collectionId, data: { _id, display }},
   *   ...
   * }
   */

  const {
    data,
    status,
    // isRefetching, // <--
    // tagType,
    tagCategory,
    // tagSegment
  } = useGetTypeCategoryAndTags({
    tagTypeProp: showTagsLightbox.tagType,
    incExcTagsList: showTagsLightbox.incExcTagsList,
    enableDataFetch: !!showTagsLightbox.tagType,
    filtersProp:
      activeLightboxFilters && Object.keys(activeLightboxFilters).length > 0
        ? Object.keys(activeLightboxFilters).reduce(
            (acc, key) => ({
              ...acc,
              ...(activeLightboxFilters[key].data?.length > 0
                ? {
                    [`tags.${key}.data._id`]: {
                      $in: activeLightboxFilters[key].data.map((d) => d._id),
                    },
                  }
                : {}),
            }),
            {}
          )
        : undefined,
    content: value,
  });

  const [searchValue, setSearchValue] = useState(undefined);
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const subMenuRef = useRef();
  const scrollableRef = useRef();

  const [pos, setPos] = useState({ visibility: "hidden" });
  const [showAddTag, setShowAddTag] = useState(false);

  const {
    right: menuRight,
    height: menuHeight,
    bottom: menuBottom,
  } = containerRef.current.parentElement.getBoundingClientRect();

  useEffect(() => {
    setSearchValue("");
    setOptions([]);
    setFilteredOptions([]);
    // if(status!=="success") return
    const menuWidth = containerRef.current.offsetWidth;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    const { top, height } = showTagsLightbox;

    const { width: subMenuWidth, height: subMenuHeight } =
      subMenuRef.current.getBoundingClientRect();

    const localPos = {
      left: menuWidth,
      top: top,
      visibility: "visible",
    };

    if (menuRight + subMenuWidth >= screenWidth) {
      localPos.right = localPos.left;
      delete localPos.left;
    }

    const mainMenuHeightNSubmenuHeightDiff = Math.abs(
      subMenuHeight - menuHeight
    );

    // console.log({ mainMenuHeightNSubmenuHeightDiff })

    if (menuBottom + top >= screenHeight) {
      localPos.top = -(
        menuHeight -
        (top + height + mainMenuHeightNSubmenuHeightDiff)
      );
    }

    setPos(localPos);
  }, [showTagsLightbox.tagType, status]);

  const handleOptionClick = (option) => {
    let prev = convertTagsValueToMultiValue(value[showTagsLightbox.tagType]);

    let newValue = prev?.length > 0 ? cloneDeep(prev) : undefined;
    if (newValue) {
      if (newValue.some((dd) => dd.value === option.value)) {
        newValue = newValue.filter((dd) => dd.value !== option.value); //deselect
      } else {
        newValue.push(option); //select
      }
    } else {
      newValue = [option];
    }

    onChange(
      showTagsLightbox.tagType,
      convertMultiValueToTagsValue(showTagsLightbox.tagType, newValue)
    );
  };

  useEffect(() => {
    if (status === "success") {
      const newOptions = convertTagDocsDataToOptions(data, "tags");
      setOptions(newOptions);
      setFilteredOptions(newOptions);
    }
  }, [status, data, showTagsLightbox.tagType]);

  useEffect(() => {
    if (!searchValue) {
      setFilteredOptions(options);
    } else {
      const filtered = searchValue
        ? options.filter((item) =>
            item?.display?.toLowerCase().includes(searchValue?.toLowerCase())
          )
        : options;
      setFilteredOptions(filtered);
    }
  }, [searchValue]);

  const getDesc = (d, descPath) => {
    const val = getVal(d, descPath);
    return Array.isArray(val) ? val.join(', ') : val;
  }

  return (
    <SubMenuWrapperStyled {...pos} ref={subMenuRef}>
      <SubMenuContainerStyled ref={scrollableRef}>
        <div style={{ backgroundColor: colors2.white }}>
          {showTagsLightbox.lightboxFilterConfigs && (
            <LightboxFilterModule
              activeLightboxFilters={activeLightboxFilters}
              setActiveLightboxFilters={setActiveLightboxFilters}
              lightboxFilterConfigs={showTagsLightbox.lightboxFilterConfigs}
            />
          )}

          <StyledSearchWrapper style={{ padding: "0 0.8rem" }}>
            <TextInput
              S
              icon={"MagnifyingGlass"}
              placeholder={"Search"}
              style={{ padding: "0 15px" }}
              value={searchValue}
              onChange={(id, value) => setSearchValue(value)}
            />
          </StyledSearchWrapper>
        </div>
        {status === "loading" ? (
          <SkeletonLoader
            style={{
              minWidth: "25rem",
              height: "21.6rem",
              backgroundColor: greyColor5,
            }}
          />
        ) : status === "error" ? (
          <span>Error</span>
        ) : (
          status === "success" && (
            <>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((d) => {
                  return (
                    <SubMenuItemStyled
                      onMouseDown={(ev) => {
                        ev.preventDefault();
                        /**
                         * stopPropagation prevents this click event from bubbling up to
                         * any of its parents, because of which several strage bugs
                         * get fixed. 1 such being the add tag textinput doesnt
                         * remove the selection from the 'to annotate' text.
                         *
                         * Another being, the svg checkbox doesnt trigget 'outside click'
                         * (for some reason svgs are not read as children of html parents)
                         * which would hide the lightbox.
                         * Not sure why this is. but worth understanding at some point
                         */
                        ev.stopPropagation();
                        handleOptionClick(d);
                      }}
                      key={d.value}
                      id={d.value}
                    >
                      <div style={{minWidth: 0}}>
                      <CheckboxInput
                        S
                        option={{
                          ...d,
                          ...(showTagsLightbox?.optionConfig?.descPath ? {desc: getDesc(d, showTagsLightbox.optionConfig.descPath)} : {})
                        }}
                        value={convertTagsValueToMultiValue(
                          value[showTagsLightbox.tagType]
                        )}
                      />
                      </div>
                    </SubMenuItemStyled>
                  );
                })
              ) : (
                <div style={{ padding: "1rem 2rem" }}>
                  <SANS_2>No results!</SANS_2>
                </div>
              )}
            </>
          )
        )}
      </SubMenuContainerStyled>

      {status === "success" &&
        showTagsLightbox.allowCreateTag !== false &&
        (showAddTag ? (
          <AddNewTagInput
            showTagsLightbox={showTagsLightbox}
            tagCategory={tagCategory}
            handleClose={() => setShowAddTag(false)}
            value={value}
            activeLightboxFilters={activeLightboxFilters}
            handleAddTag={onChange} //the naming here is a bit confusing. handleAddTag fires, only when the tag has actually been successfully created in the database, and we simply want to insert that 'tags' data into the 'selected annotation tags state'
            scrollableRef={scrollableRef}
            setShowAddTag={setShowAddTag}
          />
        ) : (
          <AddOthersStyled
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowAddTag(true);
            }}
          >
            <Plus weight="bold" size={12} />
            <SANS_2 semibold>Add Others</SANS_2>
          </AddOthersStyled>
        ))}
    </SubMenuWrapperStyled>
  );
};
